/*
 * @author Brandon Ramirez <brandon@brr.dev>
 * @copyright Copyright (c) 2024
 */

import React from 'react';
import { DarkModeContextProps } from './DarkModeContext.types';
import { DarkModeContext } from './DarkModeContext';

export function useDarkMode(): DarkModeContextProps {
    const context = React.useContext(DarkModeContext);

    if (!context) {
        throw new Error(
            'useDarkMode hook must be called from within a DarkModeContext.',
        );
    }

    return context;
}
